import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = prüft, false = abgemeldet

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        try {
          await api.post("/auth/refresh");
          const r2 = await api.get("/auth/me");
          setUser(r2.data);
        } catch {
          setUser(false);
        }
      }
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // ignorieren
    }
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
